import { Edge } from 'react-flow-renderer/dist/esm/types';

export const onEdgeRemove = (data: any, id: string) => () =>
    data.setEdges((currEdges: Edge[]) => currEdges.filter((edge: any) => edge.id !== id));
